'use client';
import React, { FC } from 'react';
import Typography from '@/components/shared/typography/typography.component';
import colors from '@/theme/colors.module.scss';
import { useTranslation, useWindowDimensions } from '@/hook';
import {
    ValueProposition,
    financingValuePropositions,
} from '@/components/car-finance/value-propositions/value-propositions';
import { SylndrSwift } from '../../../../public/Images/financing';
import { DownloadApp } from '@/components/download-app';
import { DimensionsTargets } from '@/hook/use-window-width.hook';
import { usePathname } from 'next/navigation';
import { appScreensMap } from '@/constants';
import myImageLoader from '@/image.local.loader';

const FinancingValuePropositions: FC<{ showApplyButton?: boolean }> = ({
    showApplyButton,
}) => {
    const { t } = useTranslation();
    const { IS_DESKTOP } = useWindowDimensions(DimensionsTargets.MOBILE);
    const pathname = usePathname()
        .split('/')
        .filter(segment => segment !== '')
        .slice(1)
        .join('/');
    const renderFinancingValueProposition = (
        valueProposition: ValueProposition,
        index: number
    ) => {
        return (
            <div
                className={'flex flex-col gap-2.5 items-center'}
                key={`financingValueProposition-${index}`}
            >
                <div
                    className={
                        'p-4 rounded-xl bg-white z-1 shadow-[0px_4px_10px_0px_rgba(0,0,0,0.04)]'
                    }
                >
                    <img
                        alt={valueProposition.text}
                        src={myImageLoader({
                            src: valueProposition.Icon.src,
                            height: 24,
                        })}
                        className={'w-6 '}
                    />
                </div>
                <Typography
                    variant={''}
                    className={
                        'text-center break-words max-w-[88px] text-[10px] font-semibold'
                    }
                >
                    {t(valueProposition.text)}
                </Typography>
            </div>
        );
    };
    return (
        <div
            className={
                'flex flex-col relative gap-7 px-4 pt-6 pb-5 rounded-t-2xl overflow-hidden'
            }
        >
            {showApplyButton ? (
                <div
                    className={
                        'flex flex-row w-full justify-between gap-6 items-center'
                    }
                >
                    <div className={'flex flex-row gap-3.5 items-center '}>
                        <img
                            alt={'sylndr-swift'}
                            src={myImageLoader({
                                src: SylndrSwift.src,
                                height: 24,
                            })}
                            className={'w-[108px] hidden md:inline'}
                        />
                        <Typography
                            variant={'body1SemiBold'}
                            color={colors.gray800}
                        >
                            {t('FinancingTutorialHeader')}
                        </Typography>
                        <img
                            alt={'sylndr-swift'}
                            src={myImageLoader({
                                src: SylndrSwift.src,
                                height: 24,
                            })}
                            className={'w-[108px] inline md:hidden'}
                        />
                    </div>
                    {IS_DESKTOP && (
                        <DownloadApp
                            className="md:!w-max"
                            source="Swift Banner in Car’s Listing"
                        />
                    )}
                </div>
            ) : (
                <div
                    className={
                        'flex flex-row w-full justify-between gap-6 items-center'
                    }
                >
                    <Typography
                        variant={'body1SemiBold'}
                        color={colors.gray800}
                    >
                        {t('FinancingTutorialHeader')}
                    </Typography>
                    <img
                        alt={'sylndr-swift'}
                        src={myImageLoader({
                            src: SylndrSwift.src,
                            height: 24,
                        })}
                        className={'w-[108px]'}
                    />
                </div>
            )}
            <div
                className={
                    'grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 w-full gap-y-4 '
                }
            >
                {financingValuePropositions.map(
                    renderFinancingValueProposition
                )}
            </div>
            {showApplyButton && !IS_DESKTOP && (
                <DownloadApp
                    source="Swift Banner in Car’s Listing"
                    deepLink={appScreensMap
                        .filter(item => item.websiteRoute == pathname)?.[0]
                        ?.targetScreen()}
                />
            )}
            <div
                className={
                    'bg-financing-gradient shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] -z-10 opacity-10 absolute w-full h-full top-0 left-0 pointer-events-none'
                }
            />
        </div>
    );
};

export default FinancingValuePropositions;
